import type { AdvancedDashboardData } from './dashboardAdvancedTypes';
import type { DashboardSectionResponse } from './api';
import type { DashboardResponse } from './api';
import type { KPIData } from './DashboardContext';

export const DASHBOARD_CORE_SECTIONS = [
  'sales',
  'payments',
  'inventory',
  'debt',
  'activity',
  'wallet',
] as const;

export type DashboardCoreSection = (typeof DASHBOARD_CORE_SECTIONS)[number];
export type DashboardSection = DashboardCoreSection | 'advanced';

export const emptySectionLoading = (
  loading: boolean,
  includeAdvanced: boolean,
): Record<DashboardSection, boolean> => ({
  sales: loading,
  payments: loading,
  inventory: loading,
  debt: loading,
  activity: loading,
  wallet: loading,
  advanced: includeAdvanced ? loading : false,
});

export const anySectionLoading = (
  sectionLoading: Record<DashboardSection, boolean>,
): boolean => Object.values(sectionLoading).some(Boolean);

export const assembleDashboardResponse = (
  sections: Partial<Record<DashboardCoreSection, DashboardSectionResponse>>,
  advanced?: AdvancedDashboardData,
): DashboardResponse => {
  const kpi: Partial<KPIData> = {};
  const merged: Partial<DashboardResponse> = {};

  for (const name of DASHBOARD_CORE_SECTIONS) {
    const data = sections[name];
    if (!data) continue;
    if (data.kpi) Object.assign(kpi, data.kpi);
    const { kpi: _k, ...rest } = data;
    Object.assign(merged, rest);
  }

  return {
    ...(merged as Omit<DashboardResponse, 'kpi' | 'advanced'>),
    kpi: kpi as KPIData,
    ...(advanced ? { advanced } : {}),
  };
};